module.exports = __webpack_public_path__ + "nunito-sans-latin-800italic.4f4e7a921cc52e9458245f66eb550004.woff";